export default {
    getAssessmentRubricById: '/assessmentRubric/getAssessmentRubricById',
    updateAssessmentRubricDetails: '/assessmentRubric/updateAssessmentRubricDetails',
    getExistingRubrics: '/assessmentRubric/getAssessmentRubricsOfSubject'
}
